<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">{{translations('navbar.sale_management')}}</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{translations('receivable.archive_accounts_receivable')}}</li>
      </ol>
    </nav>
    <div class="container-fluid main-container">
      <div class="form-inline mb-4 justify-content-between">
        <div class="d-flex flex-wrap align-items-center">
          <div class="form-group mr-1">
            <input id='dtSearch' type="text" class="form-control" v-model='dtSearch' :placeholder="translations('common.keyword_search')">
          </div>
          <div class="form-group mr-3">
            <v-select
              :value="master_clients.find(m => m.id === client_id) || ''"
              :options="master_clients"
              label="name"
              :placeholder="translations('receivable.billing_address')"
              :id="client_id"
              @input="changedClients">
            </v-select>
          </div>
          <div class="form-group mr-3 d-flex align-items-center">
            <span class="text-nowrap mr-1">{{translations('receivable.date')}}</span>
<!--            <input v-model="aggregatedAt" type="date" class="form-control" @blur='triggerDateFilter()' @focus='tempDateField = aggregatedAt'>-->
            <input v-model="aggregatedAt" type="date" class="form-control">
          </div>
          <div class="form-group mr-2">
            <div class="form-check">
              <input v-model="displayAll" class="form-check-input pointer-clickable" id="displayAll" type="checkbox" value="" >
              <label class="form-check-label pointer-clickable" for="displayAll">
                {{ translations('common.display_all') }}
              </label>
            </div>
          </div>
          <div class="form-group">
            <button class="btn btn-primary btn-sm" type="button" @click="submitSearch">{{translations('common.search')}}</button>
          </div>
        </div>
        <div class="form-inline justify-content-end">
          <div class="form-group" style="margin: 1px 10px 0 0">
            <button class="btn btn-primary btn-sm" type="button" @click="exportCsv">{{translations('common.csv_export')}}</button>
          </div>
          <p class="mb-0">{{translations('receivable.total_accounts_receivable')}}：<span id="receivable-sum" class="font-weight-bold">{{ sumTotalAccountReceivable.toLocaleString() }}</span></p>
        </div>
      </div>
      <div class="table-scroll mb-4">

        <v-data-table
          class="table table-striped table-hover table-800"
          item-key="name"
          :headers="[
            { text: 'No', value: '', sortable: false },
            { text: this.translations('receivable.date'), value: 'base_date' },
            { text: this.translations('receivable.billing_address'), value: 'bill_to' },
            { text: this.translations('receivable.previous_accounts_receivable'), value: 'previous_accounts_receivable' },
            { text: this.translations('receivable.current_accounts_receivable'), value: 'accounts_receivable' },
            { text: this.translations('receivable.payment'), value: 'payment' },
            { text: this.translations('receivable.accounts_receivable_balance'), value: 'total_accounts_receivable' },
          ]"
          :items="receivable"
          hide-default-footer
          :options.sync="options"
          :server-items-length="totalCount"
          @page-count="pageCount = $event"
        >
          <template v-slot:body="{ items }">
            <tbody class="nowrap">
              <template v-if="!isEmpty">
              <tr v-for="(item, i) in items" :key='i' data-href="">
                <td>{{i + 1}}</td>
                <td>{{ $invoiceTools.formatDate(item.base_date + '') }}</td>
                <td>{{ item.bill_to }}</td>
                <td class="right">{{ Number(item.previous_accounts_receivable).toLocaleString() }}</td>
                <td class="right">{{ Number(item.accounts_receivable).toLocaleString() }}</td>
                <td class="right">{{ Number(item.payment).toLocaleString() }}</td>
                <td class="right">{{ Number(item.total_accounts_receivable).toLocaleString() }}</td>
              </tr>
              </template>
              <template v-else>
                <tr class="odd">
                  <td valign="top" colspan="12" class="dataTables_empty">{{ isEmptyMsg }}</td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-data-table>
      </div>
      <v-pagination v-model="page" :length="pageCount" :total-visible="11"></v-pagination>
    </div>
    <vue-element-loading :active="isSearching" :is-full-screen="true"/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'
import { saveAs } from 'file-saver'
import Papa from 'papaparse'
import encoding from 'encoding-japanese'

export default {
  name: 'ArchiveAccountsReceivable',
  props: {},
  components: {
    VueElementLoading
  },
  computed: {
    ...mapState(['currentLanguage']),
    master_clients () {
      return this.$store.getters['Master/getBillTo']
    }
  },
  watch: {
    dtSearch (v) {
      this.$storage.set('ArchiveAccountsReceivable:dtSearch', v) // KEEP KEYWORD
    },
    page () {
      this.triggerFilter()
    },
    options: {
      handler: async function (val, oldVal) {
        let visitCount = Number(localStorage.getItem('visitCountAccountsReceivable')) || 0
        if (visitCount > 0) {
          await this.triggerFilter()
        }
      },
      deep: true
    }
  },
  data () {
    return {
      dtSearch: this.$storage.get('ArchiveAccountsReceivable:dtSearch') || '',
      isLoading: false,
      isSearching: false,
      client_id: 0,
      aggregatedAt: this.$invoiceTools.getCurrentFormatDate(),
      receivable: [],
      isEmpty: false,
      isEmptyMsg: '',
      // tempDateField: '',
      page: 1,
      pageCount: null,
      totalCount: 0,
      sumTotalAccountReceivable: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      displayAll: false
    }
  },
  created: async function () {
    this.$store.dispatch('Master/checkBillTo')
    this.$storage.set('ArchiveAccountsReceivableParam:aggregated_at', this.aggregatedAt)
    let storedFilter = this.$storage.get('ArchiveAccountsReceivableParam')

    if (storedFilter) {
      this.client_id = storedFilter.client_id ? parseInt(storedFilter.client_id) : 0
      this.aggregatedAt = storedFilter.aggregated_at
      this.options.sortBy = storedFilter.order_by
      this.options.sortDesc = storedFilter.is_desc
    }
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    async listAccountsReceivable () {
      this.isSearching = true
      const orderbys = JSON.parse(JSON.stringify(this.options.sortBy))
      const isDescs = JSON.parse(JSON.stringify(this.options.sortDesc))
      try {
        let params = {
          client_id: this.client_id,
          aggregated_at: this.aggregatedAt,
          orderbys: orderbys,
          is_descs: isDescs
        }
        let accountsReceivableList = await this.$http.post(this.$api_url.receivable_list, params)

        let $data = this.$invoiceTools.prepareResult(accountsReceivableList.data, 'list', 'ArchiveAccountsReceivable:listAccountsReceivable')
        if ($data.success === true) {
          this.receivable = $data.data
          localStorage.setItem('visitCountAccountsReceivable', this.receivable.length)
          this.isSearching = false
        } else {
          this.receivable = []
          this.isSearching = false
        }
      } catch (error) {
        this.isSearching = false
        console.log('ArchiveAccountsReceivable:listAccountsReceivable:catch(error): ', error)
        this.$toastr.error(this.translations('receivable.notice_failed'), this.translations('common.error'))
      }
    },

    getFilterTxt (obj, input, output, _default) {
      if (input) {
        if (input === 0) return _default
        return this.$invoiceTools.getObjPropsById(obj, input, output)
      }
      return _default
    },

    initList () {
      if (this.page !== 1) {
        this.page = 1
      } else {
        this.triggerFilter()
      }
    },

    async triggerFilter (field, val) {
      try {
        if (!this.aggregatedAt) {
          this.$toastr.warning(this.translations('receivable.notice_select_date'), '')
          return
        }

        if (this.displayAll) {
          this.$storage.set('account_receivable_display_all', this.displayAll)
          this.options.itemsPerPage = -1 // DISPLAY ALL
        } else {
          this.options.itemsPerPage = 10 // DISPLAY 10 ROWS
        }

        this.isSearching = true

        const offset = (this.page - 1) * this.options.itemsPerPage
        const limit = this.options.itemsPerPage
        const orderBy = JSON.parse(JSON.stringify(this.options.sortBy))
        const isDesc = JSON.parse(JSON.stringify(this.options.sortDesc))

        let params = {
          client_id: this.client_id,
          aggregated_at: this.aggregatedAt,
          search: this.dtSearch,
          order_by: orderBy,
          is_desc: isDesc,
          offset: offset,
          limit: limit
        }

        this.$storage.set('ArchiveAccountsReceivableParam', params)
        console.log('ArchiveAccountsReceivable:triggerFilter: ', params)

        try {
          let filteredReceivableList = await this.$http.post(this.$api_url.receivable_list, params)

          let $data = filteredReceivableList.data
          if ($data.status === true) {
            this.isEmpty = false
            this.isEmptyMsg = ''
            this.receivable = $data.list
            localStorage.setItem('visitCountAccountsReceivable', this.receivable.length)
            this.totalCount = Number($data.total_count)
            this.sumTotalAccountReceivable = $data.sum_total_account_receivable
          } else {
            this.receivable = []
          }
        } catch (error) {
          console.log('ArchiveAccountsReceivable:listAccountsReceivable:catch(error): ', error)
          this.$toastr.error(this.translations('receivable.notice_failed'), this.translations('common.error'))
        }
        this.isSearching = false
      } catch (e) {
        this.isEmpty = true
        this.isEmptyMsg = this.translations('receivable.notice_failed')
        this.isSearching = false
        console.log('ArchiveAccountsReceivable:API:triggerFilter: error: ', e)
        this.$toastr.error(this.translations('receivable.notice_failed'), this.translations('common.error'))
      }
    },

    // triggerDateFilter (source) {
    //   if (!this.aggregatedAt) {
    //     this.$toastr.warning('日付を選択してください。', '')
    //     return
    //   }
    //   if (this.aggregatedAt !== this.tempDateField) {
    //     this.triggerFilter()
    //   }
    // },

    changedClients (event) {
      if (!event) {
        this.client_id = 0
        return
      }
      this.client_id = event.id
    },

    submitSearch () {
      this.triggerFilter()
    },

    async exportCsv () {
      try {
        if (!this.aggregatedAt) {
          this.$toastr.warning(this.translations('receivable.notice_select_date'), '')
          return
        }

        this.isSearching = true

        const orderBy = JSON.parse(JSON.stringify(this.options.sortBy))
        const isDesc = JSON.parse(JSON.stringify(this.options.sortDesc))

        let params = {
          client_id: this.client_id,
          aggregated_at: this.aggregatedAt,
          search: this.dtSearch,
          order_by: orderBy,
          is_desc: isDesc
        }

        this.$storage.set('ArchiveAccountsReceivableParam', params)
        console.log('ArchiveAccountsReceivable:exportCsv: ', params)

        try {
          let filteredReceivableList = await this.$http.post(this.$api_url.receivable_csv, params)

          let $data = filteredReceivableList.data
          if ($data.status === true) {
            this.isEmpty = false
            this.isEmptyMsg = ''
            this.saveCsv_($data.list)
          } else {
            this.receivable = []
          }
        } catch (error) {
          console.log('ArchiveAccountsReceivable:listAccountsReceivable:catch(error): ', error)
          this.$toastr.error(this.translations('receivable.notice_failed'), this.translations('common.error'))
        }
        this.isSearching = false
      } catch (e) {
        this.isEmpty = true
        this.isEmptyMsg = this.translations('receivable.notice_failed')
        this.isSearching = false
        console.log('ArchiveAccountsReceivable:API:exportCsv: error: ', e)
        this.$toastr.error(this.translations('receivable.notice_failed'), this.translations('common.error'))
      }
    },

    saveCsv_ (list) {
      const data = []
      list.forEach(item => {
        data.push([
          item.base_date,
          item.bill_to,
          item.previous_accounts_receivable,
          item.accounts_receivable,
          item.payment,
          item.total_accounts_receivable
        ])
      })
      let csv = ''
      csv = Papa.unparse({
        fields: [
          this.translations('receivable.date'),
          this.translations('receivable.billing_address'),
          this.translations('receivable.previous_accounts_receivable'),
          this.translations('receivable.current_accounts_receivable'),
          this.translations('receivable.payment'),
          this.translations('receivable.accounts_receivable_balance')
        ],
        data: data
      })

      const unicodeList = encoding.stringToCode(csv)
      const sjisArray = encoding.convert(unicodeList, 'SJIS', 'UNICODE')
      const uInt8List = new Uint8Array(sjisArray)
      const content = new Blob([uInt8List], { type: 'text/csv' })
      const d = new Date()
      const filename = this.translations('receivable.receivable_') + d.getFullYear() +
        ('0' + (d.getMonth() + 1)).slice(-2) +
        ('0' + d.getDate()).slice(-2) + '_' +
        ('0' + d.getHours()).slice(-2) +
        ('0' + d.getMinutes()).slice(-2) +
        ('0' + d.getSeconds()).slice(-2) + '.csv'
      saveAs(content, filename)
      this.isLoading = false
    }
  }
}
</script>

<style>
#tbl-accounts-receivable_wrapper .col-sm-12{
  padding-right: 0 !important;
}
</style>
